import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Div100vh from "react-div-100vh";

import mixpanel from "mixpanel-browser";
import { userDataAtom } from "@/recoil/atom/userDataAtom";
import { useRecoilValue } from "recoil";
import { chatHelpMessage, trackBtnClick, inviteFriends } from "@/lib/helper";
import NewUserContent from "@/components/journey/HomeComponents/NewUserContent.jsx";
import OnboardedUserContent from "@/components/journey/HomeComponents/OnboardedUserContent.jsx";
import NewMemberCard from "../common/Card/NewMembershipCard";

import WhatsappIcon from "@/assets/icons/whatsapp-icon.svg";
// import WhatsappIcon from "@/assets/icons/whatsapp-icon-green.svg";
import BlueCoinsIcon from "@/assets/icons/BlueCoins.svg";
import ArrowIcon from "@/assets/icons/arrow-icon.svg";

import home from "@/assets/icons/navbar/home.svg";
import home_active from "@/assets/icons/navbar/home_active.svg";
import cb_active from "@/assets/icons/navbar/cb_active.svg";
import cb from "@/assets/icons/navbar/cb.svg";
import hiw from "@/assets/icons/navbar/hiw.svg";
import hiw_active from "@/assets/icons/navbar/hiw_active.svg";
import profile from "@/assets/icons/navbar/profile.svg";
import profile_active from "@/assets/icons/navbar/profile_active.svg";

import { ArrowUpRight, HelpCircleIcon } from "lucide-react";
import Profile from "./Profile";
import ClubWorkScreen from "../common/screens/ClubWorkScreen";
import HowItWorks from "./HowItWorks";
import ReferralPageNew from "./new-reffer-screen";

const NewHomeScreen = ({ currentPage, setCurrentPage }) => {
  const navigate = useNavigate();
  const userData = useRecoilValue(userDataAtom);

  useEffect(() => {
    if (userData) {
      // mixpanel.identify(userData.userId);

      // mixpanel.people.set({
      //   $name: [userData.firstName, userData.middleName, userData.lastName]
      //     .filter(Boolean)
      //     .join(" "),
      //   $phone: userData.phone,
      //   plan: "Premium",
      // });

      if (userData?.isEligible === null && userData?.approval.length === 0) {
        const redirectCount = parseInt(localStorage.getItem("FE_CHECK") || 0);
        if (redirectCount <= 3) {
          localStorage.setItem("FE_CHECK", redirectCount + 1);
          navigate("/eligibility-check", {
            state: {
              afterCheck: "/about",
            },
          });
        }
      }
    }
  }, [userData]);

  const landlordDataAvailable =
    userData?.landlord &&
    Array.isArray(userData.landlord) &&
    userData.landlord.length > 0;

  return (
    <Div100vh className="flex flex-col bg-contain relative bg-no-repeat overflow-y-scroll justify-between pb-4">
      {currentPage === 0 && (
        <div className="flex flex-col justify-start gap-4 md:h-full overflow-scroll">
          <div className="flex flex-col w-full">
            {/* Header Section */}
            <div className="flex justify-between items-center p-6">
              <div className="relative group">
                <button className="flex gap-2 items-center justify-center border py-1 pl-4 pr-2 rounded-full border-[#333]">
                  <span
                    className={`text-[12px] tracking-wide font-medium ${
                      userData?.isEligible === true
                        ? "bg-gradient-to-r from-[#00680C] via-[#47FFA7] to-[#00680C] text-transparent bg-clip-text"
                        : userData?.isEligible === false
                        ? "bg-gradient-to-r from-[#830006] via-[#FF5959] to-[#870000] text-transparent bg-clip-text"
                        : "bg-gradient-to-r from-[#FFDF6B] via-[#EEEEEE] to-[#FFDF6B] text-transparent bg-clip-text"
                    }`}
                  >
                    {userData?.approval.length < 1
                      ? "Pending"
                      : userData?.isEligible === true
                      ? "Eligible"
                      : userData?.isEligible === false
                      ? "Not Eligible"
                      : "Pending"}
                  </span>
                  <HelpCircleIcon className="stroke-1 w-5 text-[#777]" />
                </button>
                <div className="absolute flex items-center justify-center z-10 left-0 top-full mt-2 min-w-64 font-sans font-medium bg-[#eee] text-[#222] text-3xs py-2 px-4 rounded-md opacity-0 group-hover:opacity-100 group-focus:opacity-100 transition-opacity">
                  {userData?.approval.length < 1 ? (
                    <span className="flex gap-1">
                      Check your Eligibility
                      <a
                        onClick={() => {
                          trackBtnClick(
                            "Check Here",
                            "Home Page",
                            "Check Eligibilty"
                          );
                          navigate("/eligibility-check");
                        }}
                        className="flex items-center text-[#0031fb]"
                      >
                        check now <ArrowUpRight className="size-3" />
                      </a>
                    </span>
                  ) : userData?.isEligible === true ? (
                    <span>Congrats your are Eligible for club benefits</span>
                  ) : userData?.isEligible === false ? (
                    <span>
                      You're not Eligible but you can still ask your flatmates
                      to check eligibility on your behalf
                    </span>
                  ) : (
                    <span className="flex gap-1">
                      Check your Eligibility
                      <a
                        onClick={() => {
                          trackBtnClick(
                            "Check Here",
                            "Home Page",
                            "Check Eligibilty"
                          );
                          navigate("/eligibility-check");
                        }}
                        className="flex items-center text-[#0031fb]"
                      >
                        check now <ArrowUpRight className="size-3" />
                      </a>
                    </span>
                  )}
                </div>
              </div>
              <div className="flex gap-6 items-center">
                <button
                  onClick={() => {
                    trackBtnClick("FAQ", "Home Page");
                    navigate("/faq");
                  }}
                  className="text-xs font-semibold text-[#bbb]"
                >
                  FAQ's
                </button>
                <button
                  onClick={() => chatHelpMessage()}
                  className="rounded-xl flex text-[12px] items-center text-[#ddd] gap-2"
                >
                  <img src={WhatsappIcon} alt="Whatsapp" className="max-w-10" />
                </button>
              </div>
            </div>

            {/* Membership Card Section */}
            <div className="px-5 flex flex-col justify-center w-full">
              <NewMemberCard
                name={userData?.firstName?.toUpperCase()}
                id={userData?.referralCode}
                isEligible={userData?.isEligible}
                isMember={userData?.isMember}
              />
              {userData.isEligible === false && (
                <div className="w-full bg-[url('@/assets/images/bggrid.png')] bg-cover bg-center">
                  {landlordDataAvailable ? (
                    <OnboardedUserContent userData={userData} />
                  ) : (
                    <NewUserContent />
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Main Content Section */}
          {userData?.approval.length < 1 ? (
            <div className="px-5 w-full">
              <NewUserContent />
            </div>
          ) : userData?.isEligible === false ? (
            <div className="w-full px-5">
              <div
                className="relative flex items-center gap-4 p-4 border-t-[0.5px] border-gray-300"
                style={{
                  background: `linear-gradient(271deg, rgba(255, 255, 255, 0.00) 77.19%, rgba(255, 255, 255, 0.20) 100.23%), linear-gradient(103deg, rgba(1, 1, 1, 0.00) 0%, #00C 115.24%)`,
                }}
              >
                <img
                  src={BlueCoinsIcon}
                  alt="Blue Coins"
                  className="w-12 h-12"
                />
                <div className="flex flex-col gap-4">
                  <div className="flex flex-col gap-1">
                    <span className="text-[#999999] text-3xs font-normal">
                      If you are not eligible, No worries :)
                    </span>
                    <span className="text-[#eeeeee] text-2xs">
                      You can still ask your flatmates to check eligibility on
                      your behalf
                    </span>
                  </div>
                  <button
                    onClick={() => inviteFriends()}
                    className="flex w-fit gap-2 bg-[#000000] border border-[#7D7A7A] text-[#cccccc] text-2xs px-4 py-2 rounded"
                  >
                    <span>Send Invite</span>
                    <img src={ArrowIcon} alt="arrow icon" />
                  </button>
                </div>
                <div className="absolute top-0 left-0 h-full w-[0.5px] bg-gradient-to-b from-white to-transparent"></div>
                <div className="absolute top-0 right-0 h-full w-[0.5px] bg-gradient-to-b from-white to-transparent"></div>
              </div>
            </div>
          ) : (
            <div className="w-full px-5 bg-[url('@/assets/images/grid_hS.png')] bg-cover bg-center bg-opacity-0">
              {landlordDataAvailable ? (
                <OnboardedUserContent userData={userData} />
              ) : (
                <NewUserContent />
              )}
            </div>
          )}

          {/* Hidden Navbar for non-mobile view */}
          <div className="bg-[#171717]/0 text-gray-400/0 shadow-md py-3 px-4 rounded-xl">
            <div className="flex justify-around items-center h-16">
              {navBarList.map((data, index) => (
                <div
                  key={index}
                  className={`flex-col hidden items-center ${
                    index === currentPage
                      ? "text-white/0 font-semibold"
                      : "text-[#888]/0 font-medium"
                  }`}
                  onClick={() => {
                    if (data.path === "/how-it-works") {
                      setCurrentPage(2);
                    } else if (data.path === "/club-benefits") {
                      setCurrentPage(1);
                    } else if (data.path === "/profile") {
                      navigate(data.path);
                    } else {
                      setCurrentPage(0);
                    }
                  }}
                >
                  {data.icon}
                  <span className="se:text-3xs sm:text-2xs mt-2">
                    {data.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Other Pages */}
      {currentPage === 2 && <HowItWorks />}
      {currentPage === 3 && <Profile />}
      {currentPage === 1 && <ReferralPageNew userData={userData} />}
    </Div100vh>
  );
};

const navBarList = [
  {
    icon: (
      <img
        src={home}
        alt="Home"
        className="w-14 h-14 pointer-events-none select-none"
      />
    ),
    activeIcon: (
      <img
        src={home_active}
        alt="Home Active"
        className="w-16 h-16 pointer-events-none select-none"
      />
    ),
    name: "Home",
    path: "/",
  },

  {
    icon: (
      <img
        src={cb}
        alt="Refer & Earn"
        className="w-14 h-14 pointer-events-none select-none"
      />
    ),
    activeIcon: (
      <img
        src={cb_active}
        alt="Refer & Earn Active"
        className="w-16 h-16 pointer-events-none select-none"
      />
    ),
    name: "Refer & Earn",
    path: "/referral",
  },
  {
    icon: (
      <img
        src={hiw}
        alt="How it works"
        className="w-14 h-14 pointer-events-none select-none"
      />
    ),
    activeIcon: (
      <img
        src={hiw_active}
        alt="How it works Active"
        className="w-16 h-16 pointer-events-none select-none"
      />
    ),
    name: "How it works",
    path: "/how-it-works",
  },
  {
    icon: (
      <img
        src={profile}
        alt="Profile"
        className="w-14 h-14 pointer-events-none select-none"
      />
    ),
    activeIcon: (
      <img
        src={profile_active}
        alt="Profile Active"
        className="w-16 h-16 pointer-events-none select-none"
      />
    ),
    name: "Profile",
    path: "/profile",
  },
];

const Navbar = ({ currentPage, setCurrentPage }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-[#171717] text-gray-400 shadow-md pt-0 pb-7 px-4 w-full">
      <div className="grid grid-cols-4 gap-0 items-center justify-items-center h-10 w-full">
        {navBarList.map((data, index) => (
          <div
            key={index}
            className={`relative flex flex-col items-center w-full ${
              index === currentPage
                ? "text-white font-semibold"
                : "text-[#888] font-medium"
            }`}
            onClick={() => {
              if (data.path === "/how-it-works") {
                setCurrentPage(2);
              } else if (data?.path === "/profile") {
                setCurrentPage(3);
              } else if (data?.path === "/referral") {
                setCurrentPage(1);
              } else {
                setCurrentPage(0);
              }
            }}
          >
            <div className="flex items-center justify-center w-full h-10">
              {index === currentPage ? data?.activeIcon : data?.icon}
            </div>
            <span className="text-3xs sm:text-2xs whitespace-nowrap">
              {data.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

const HomeScreen = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [isFixed, setIsFixed] = useState(window.innerWidth < 510);

  useEffect(() => {
    const handleResize = () => {
      setIsFixed(window.innerWidth < 510);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Div100vh className="flex flex-col bg-contain relative bg-no-repeat overflow-hidden">
      <div className="flex-1 overflow-y-auto pb-16">
        <NewHomeScreen
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
      <div
        className="bottom-0 left-0 right-0 w-full backdrop-blur-xl md:backdrop-blur-0 md:bg-none z-20"
        style={{
          position: isFixed ? "fixed" : "relative",
        }}
      >
        <Navbar currentPage={currentPage} setCurrentPage={setCurrentPage} />
      </div>
    </Div100vh>
  );
};

export default HomeScreen;
